import React, { lazy, Suspense, useEffect } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import ReactGA from 'react-ga4';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { ThemeContextProvider } from '../theme';
import FullPageLoadingIndicatorContainer from '../../components/fullPageLoadingIndicator/fullPageLoadingIndicatorContainer';
import { supportedBrowsersService } from './supportedBrowserService';
import CookiePanel from '../cookiePanel';
import { DateLocaleContextProvider } from '../../environment/context';
import { openCallBackFormAction } from '../xcally';

const SHOW_CALL_ME_BACK_PARAM = 'show-call-me-back';

const App = lazy(() => import('../app/app'));
const UnsupportedApp = lazy(() => import('../unsupportedBrowserApp/unsupportedBrowserApp'));
const ModalDialogContainer = lazy(() => import('../../components/dialogManager/modalDialogContainer'));
const renderLoader = (): React.ReactElement => <FullPageLoadingIndicatorContainer size={90} />;

function BrowserBaseApp(): React.ReactElement {
  const [isBrowserSupported, setIsBrowserSupported] = React.useState<boolean>(false);
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const isBrowserSupportedResult = supportedBrowsersService().isBrowserSupported();
    setIsBrowserSupported(isBrowserSupportedResult);
  }, []);

  // Otevření callback formuláře přes query parametr na jakékoli URL (např. link z e-mailu: ...?show-call-me-back=1).
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get(SHOW_CALL_ME_BACK_PARAM) === '1') {
      dispatch(openCallBackFormAction());

      // Parametr po otevření odstraníme, aby se dialog znovu neotvíral při další navigaci.
      params.delete(SHOW_CALL_ME_BACK_PARAM);
      history.replace({ pathname: location.pathname, search: params.toString() });
    }
  }, [location.search, location.pathname, dispatch, history]);

  useEffect(() => {
    console.log(`Location changed: ${location}`);
    ReactGA.send({ hitType: 'pageview', page: location.pathname, path: location.pathname });
  }, [location.pathname]);

  const childrenComponent = isBrowserSupported ? <App /> : <UnsupportedApp />;
  console.log('BrowserBaseApp render');

  return (
    <Suspense fallback={renderLoader()}>
      <ThemeContextProvider>
        <DateLocaleContextProvider>
          <CssBaseline />
          <ModalDialogContainer />
          <FullPageLoadingIndicatorContainer size={90} />
          {childrenComponent}
          <CookiePanel />
        </DateLocaleContextProvider>
      </ThemeContextProvider>
    </Suspense>
  );
}

export default BrowserBaseApp;
